import { useRequirementFieldPath } from '../fieldPaths';
import { useQueryErrorStateContext } from '../../../contexts';

export const useResetRequirementErrors = () => {
  const { resetErrorsFromFieldPath } = useQueryErrorStateContext();
  const fieldPath = useRequirementFieldPath();
  return () => resetErrorsFromFieldPath(fieldPath);
};
